<app-header [unAuthen]="true"></app-header>
<main class="unauthen-layouts" style="padding-top: 0rem">
  <div
    class="h-100 d-flex justify-content-center align-items-center"
    style="min-height: calc(100vh - 66px - 2rem)"
  >
    @if (showCoverImg) {
      <div class="container-fluid px-0 d-flex justify-content-center">
        <div class="w-100 d-flex">
          @if (isPc$ | async) {
            <div class="position-relative d-inline-block">
              <img
                src="/assets/imgs/unauthen-cover2.png"
                class="unauthen-cover-img"
              />

              <div
                class="position-absolute bottom-0 start-0 p-2 fw-bold mx-5 my-2"
              >
                <h3 class="text-white">Kaset One SO</h3>
                <h6 class="text-white">
                  ระบบบริหารจัดการแปลงเกษตร (เจ้าหน้าที่)
                </h6>
              </div>
            </div>
          }
          <div
            class="main-bg w-100 d-flex justify-content-center h-100 align-items-center"
            style="padding-top: 1rem"
          >
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    } @else {
      <div class="container-xl d-flex justify-content-center">
        <router-outlet />
      </div>
    }

    <h6
      class="position-absolute bottom-0 end-0 text-grey-light px-5 mx-5"
      style="font-size: 0.75rem"
    >
      ©Copyright 2026 : Kaset One DE ระบบบริหารพัฒนาเกษตร
    </h6>
  </div>
</main>
